module.exports = __webpack_public_path__ + "static/media/favicon.ee67737d.png";